var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsAtsMappingIcon = function SvgSettingsAtsMappingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.332h6v1.333h-6zM10 8h6v1.333h-6zM10 10.668h6v1.333h-6zM10 13.332h6v1.333h-6zM10 16h6v1.333h-6zM7.334 5.332h1.333v1.333H7.334zM7.334 8h1.333v1.333H7.334zM7.334 10.668h1.333v1.333H7.334zM7.334 13.332h1.333v1.333H7.334zM7.334 16h1.333v1.333H7.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 1.332H5.333A1.333 1.333 0 0 0 4 2.665v18.667a1.333 1.333 0 0 0 1.333 1.333h13.334A1.333 1.333 0 0 0 20 21.332V2.665a1.333 1.333 0 0 0-1.333-1.333m0 20H5.333V2.665h13.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSettingsAtsMappingIcon;